var _excluded = ["children", "color", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { StyledAlert, StyledAlertTitle } from './StyledAlert';
var Alert = forwardRef(function (_ref, ref) {
  var children = _ref.children,
    color = _ref.color,
    title = _ref.title,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledAlert, _extends({
    color: color,
    ref: ref,
    severity: color
  }, rest), title && /*#__PURE__*/React.createElement(StyledAlertTitle, null, title), children);
});
Alert.propTypes = {
  /**
   * Node to display as close action.  Pass `false` to remove.
   */
  action: PropTypes.node,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,
  /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  closeText: PropTypes.string,
  /**
   * The main color for the alert. Unless provided, the value is taken from the `severity` prop.
   */
  color: PropTypes.oneOf(['error', 'info', 'success', 'warning']),
  /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop. Pass `false` to remove icon.
   */
  icon: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
  /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * The ARIA role attribute of the element.
   */
  role: PropTypes.string,
  /**
   * Adds a title using the AlertTitle component https://material-ui.com/api/alert-title/
   */
  title: PropTypes.node,
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
};
Alert.defaultProps = {
  action: null,
  children: null,
  classes: null,
  closeText: null,
  color: 'info',
  icon: null,
  onClose: null,
  role: '',
  title: '',
  variant: 'filled'
};
export default Alert;